/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const SKELETON_ROW_COUNT = 6;

const styles = cssMap({
	listWrapper: {
		flex: 1,
		minHeight: '0px',
		overflowY: 'auto',
		scrollbarGutter: 'stable',
		paddingLeft: token('space.250'),
		paddingRight: token('space.075'),
		paddingTop: token('space.100'),
		listStyle: 'none',
		marginTop: token('space.0'),
	},
	browseItemRow: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.150'),
		width: '100%',
		height: '56px',
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
		paddingTop: token('space.075'),
		paddingBottom: token('space.075'),
	},
	iconContainer: {
		width: '32px',
		height: '32px',
		minWidth: '32px',
		flexShrink: 0,
		borderRadius: token('radius.small'),
		border: `${token('border.width')} solid ${token('color.border')}`,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	textStack: {
		flex: 1,
		minWidth: '0px',
	},
});

export type InlineBrowseSkeletonProps = {
	rowCount?: number;
	testId?: string;
};

export const InlineBrowseSkeleton = ({
	rowCount = SKELETON_ROW_COUNT,
	testId = 'inline-browse-skeleton',
}: InlineBrowseSkeletonProps): JSX.Element => {
	return (
		<Stack space="space.050" xcss={styles.listWrapper} as="ul" testId={testId}>
			{Array.from({ length: rowCount }).map((_, index) => (
				<Box key={index} as="li" xcss={styles.browseItemRow}>
					<Box xcss={styles.iconContainer}>
						<Skeleton width={20} height={20} isShimmering borderRadius={token('radius.small')} />
					</Box>
					<Stack space="space.025" xcss={styles.textStack}>
						<Skeleton width="70%" height={16} isShimmering borderRadius={token('radius.small')} />
						<Skeleton width="50%" height={12} isShimmering borderRadius={token('radius.small')} />
					</Stack>
				</Box>
			))}
		</Stack>
	);
};
